import * as rq from '@tanstack/react-query';
import { z } from 'zod';

import { RoleSchema } from '../entities/role';

import { getRolesPaginated } from './__mocked_data__/roles-state';

export namespace GetRolesQuery {
  export const key = (input: Input) => [
    'user-management',
    'roles',
    input.page,
    input.pageSize,
  ];

  export type Input = { page: number; pageSize: number };

  export const OutputSchema = z.object({
    totalCount: z.number(),
    previousPage: z.number().optional(),
    currentPage: z.number(),
    nextPage: z.number().optional(),
    roles: z.array(
      RoleSchema.pick({
        id: true,
        name: true,
        permission: true,
        sites: true,
        userCount: true,
      }),
    ),
  });
  export type Output = z.infer<typeof OutputSchema>;

  function outputMapper(input: Input): Output {
    const result = getRolesPaginated(input);
    return result;
  }

  function useQueryFn() {
    return async function queryFn(input: Input) {
      const output = await OutputSchema.parseAsync(outputMapper(input));
      return output;
    };
  }

  export function useQuery(input: Input) {
    const queryFn = useQueryFn();

    return rq.useQuery<Output>({
      queryKey: key(input),
      queryFn: () => queryFn(input),
      keepPreviousData: true,
    });
  }

  export function usePrefetch() {
    const queryClient = rq.useQueryClient();
    const queryFn = useQueryFn();

    return async function prefetch(input: Input): Promise<void> {
      await queryClient.prefetchQuery<Output>({
        queryKey: key(input),
        queryFn: () => queryFn(input),
      });
    };
  }
}
